// Mock data for Corporativo MK website

export const companyInfo = {
  name: "Corporativo MK",
  tagline: "Espacios que impulsan tu negocio",
  description: "Somos líderes en soluciones de espacios corporativos y coworking, ofreciendo ambientes modernos y funcionales para empresas que buscan crecer.",
  phone: "+52 1 314 157 7129",
  email: "contacto@corporativomk.com",
  address: "Carretera Manzanillo - Minatitlán km 1.2, #1198, Tapeixtles, 28239",
  hours: "Lunes a Viernes: 8:00 AM - 7:00 PM",
  social: {
    linkedin: "#",
    instagram: "#",
    facebook: "#"
  }
};

export const services = [
  {
    id: 1,
    title: "Oficinas Privadas",
    description: "Espacios exclusivos totalmente equipados con privacidad y seguridad para tu equipo de trabajo.",
    icon: "Building2",
    features: ["Mobiliario ejecutivo", "Internet de alta velocidad", "Acceso 24/7", "Servicios incluidos"]
  },
  {
    id: 2,
    title: "Coworking",
    description: "Áreas compartidas diseñadas para fomentar la colaboración y el networking entre profesionales.",
    icon: "Users",
    features: ["Escritorios flexibles", "Áreas comunes", "Eventos de networking", "Café y snacks"]
  },
  {
    id: 3,
    title: "Salas de Juntas",
    description: "Espacios profesionales para reuniones ejecutivas con tecnología de punta.",
    icon: "Presentation",
    features: ["Videoconferencia", "Pantallas interactivas", "Servicio de café", "Capacidad variable"]
  },
  {
    id: 4,
    title: "Oficinas Virtuales",
    description: "Presencia corporativa sin necesidad de espacio físico permanente.",
    icon: "Globe",
    features: ["Dirección fiscal", "Recepción de correspondencia", "Atención telefónica", "Uso de salas"]
  },
  {
    id: 5,
    title: "Eventos Corporativos",
    description: "Espacios versátiles para capacitaciones, presentaciones y eventos empresariales.",
    icon: "Calendar",
    features: ["Auditorio equipado", "Catering disponible", "Soporte técnico", "Estacionamiento"]
  },
  {
    id: 6,
    title: "Domicilio Fiscal",
    description: "Dirección comercial de prestigio para tu empresa con servicios administrativos.",
    icon: "MapPin",
    features: ["Ubicación premium", "Gestión de correspondencia", "Facturación", "Asesoría legal"]
  }
];

export const spaces = [
  {
    id: 1,
    name: "Suite Ejecutiva Premium",
    type: "Oficina Privada",
    size: "45 m²",
    capacity: "6-8 personas",
    price: "$25,000 MXN/mes",
    image: "https://images.unsplash.com/photo-1606836576983-8b458e75221d?w=800&q=80",
    features: ["Vista panorámica", "Sala de juntas privada", "Recepcionista", "Estacionamiento incluido"],
    available: true,
    location: "Torre Norte, Piso 20"
  },
  {
    id: 2,
    name: "Espacio Coworking Flex",
    type: "Coworking",
    size: "Escritorio individual",
    capacity: "1 persona",
    price: "$4,500 MXN/mes",
    image: "https://images.unsplash.com/photo-1527192491265-7e15c55b1ed2?w=800&q=80",
    features: ["Acceso 24/7", "Casillero personal", "Impresión incluida", "Áreas de descanso"],
    available: true,
    location: "Torre Central, Piso 8"
  },
  {
    id: 3,
    name: "Oficina Corporativa A",
    type: "Oficina Privada",
    size: "120 m²",
    capacity: "15-20 personas",
    price: "$65,000 MXN/mes",
    image: "https://images.unsplash.com/photo-1556761175-4b46a572b786?w=800&q=80",
    features: ["Diseño personalizable", "Sala de capacitación", "Kitchenette", "Fibra óptica"],
    available: true,
    location: "Torre Sur, Piso 12"
  },
  {
    id: 4,
    name: "Sala de Juntas Elite",
    type: "Sala de Juntas",
    size: "35 m²",
    capacity: "12 personas",
    price: "$800 MXN/hora",
    image: "https://images.unsplash.com/photo-1610374792793-f016b77ca51a?w=800&q=80",
    features: ["Sistema de videoconferencia", "Pantalla 4K", "Pizarrón digital", "Servicio de café"],
    available: true,
    location: "Torre Norte, Piso 25"
  },
  {
    id: 5,
    name: "Hub Colaborativo",
    type: "Coworking",
    size: "Área compartida",
    capacity: "1-4 personas",
    price: "$8,500 MXN/mes",
    image: "https://images.unsplash.com/photo-1553028826-f4804a6dba3b?w=800&q=80",
    features: ["Mesa grupal", "Zona de networking", "Eventos semanales", "Café ilimitado"],
    available: false,
    location: "Torre Central, Piso 5"
  },
  {
    id: 6,
    name: "Oficina Startup",
    type: "Oficina Privada",
    size: "25 m²",
    capacity: "3-4 personas",
    price: "$12,000 MXN/mes",
    image: "https://images.unsplash.com/photo-1606836576983-8b458e75221d?w=800&q=80",
    features: ["Ambiente dinámico", "Mentoría incluida", "Acceso a inversores", "Internet premium"],
    available: true,
    location: "Torre Sur, Piso 3"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "María González",
    position: "CEO, Tech Solutions",
    content: "Corporativo MK transformó nuestra forma de trabajar. Las instalaciones son impecables y el servicio excepcional.",
    rating: 5
  },
  {
    id: 2,
    name: "Carlos Mendoza",
    position: "Director, Finanzas Plus",
    content: "La ubicación y las amenidades superaron nuestras expectativas. Nuestro equipo está más productivo que nunca.",
    rating: 5
  },
  {
    id: 3,
    name: "Ana Martínez",
    position: "Fundadora, CreativeHub",
    content: "El ambiente de coworking es perfecto para networking. He hecho conexiones invaluables aquí.",
    rating: 5
  }
];

export const stats = [
  { value: "15+", label: "Años de experiencia" },
  { value: "500+", label: "Empresas atendidas" },
  { value: "50,000", label: "m² administrados" },
  { value: "98%", label: "Satisfacción del cliente" }
];

export const aboutContent = {
  mission: "Proporcionar espacios de trabajo excepcionales que impulsen el crecimiento y éxito de las empresas, combinando diseño innovador con servicios de primera clase.",
  vision: "Ser el referente en soluciones de espacios corporativos en México, reconocidos por nuestra excelencia, innovación y compromiso con nuestros clientes.",
  values: [
    { title: "Excelencia", description: "Nos esforzamos por superar las expectativas en cada detalle." },
    { title: "Innovación", description: "Adoptamos las últimas tendencias en diseño y tecnología." },
    { title: "Compromiso", description: "Tu éxito es nuestra prioridad número uno." },
    { title: "Integridad", description: "Operamos con transparencia y honestidad en todo momento." }
  ],
  history: "Fundado en 2009, Corporativo MK nació con la visión de revolucionar el concepto de espacios de trabajo en México. Lo que comenzó como un pequeño edificio de oficinas, hoy se ha convertido en un referente del sector inmobiliario corporativo, con presencia en las zonas más exclusivas de la ciudad."
};
